import { IssueImageEditingContextValue } from "./IssueImageEditingContext.types";
import { createContext } from "react";

export const IssueImageEditingContext = createContext<
  IssueImageEditingContextValue | undefined
>(undefined);
